<template>
  <CDropdown inNav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0 mr-2">
    <template #toggler>
      <CHeaderNavLink class="mr-3 pld-0 pr-0">
        <div class="c-avatar">
          <img src="/static/img/avatars/amazing.gif" class="c-avatar-img "/>
          <!-- <i data-v-7983366c="" class="fa fa-user-circle-o" style="font-size: 1.5em;"></i> -->
        </div>
        <span style="font-weight:400; font-size: 1em; line-height: 1;">{{ fullName }}</span>
        <span class="fa fa-angle-down ml-1"></span>
      </CHeaderNavLink>
    </template>
    <CDropdownItem @click="logout()">
      <svg class="menu-item-img" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
           y="0px" viewBox="0 0 100 100">
        <switch>
          <foreignObject requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/" x="0" y="0" width="1"
                         height="1"></foreignObject>
          <g i:extraneous="self">
            <g>
              <path
                d="M63.8,29.3v11.3H34.1c-1.5,0-2.7,1.2-2.7,2.7v13.5c0,1.5,1.2,2.7,2.7,2.7h29.7v11.3c0,2.7,3.1,4.2,5.2,2.6l27.2-20.7     c1.7-1.3,1.7-3.9,0-5.2L69,26.7C66.9,25,63.8,26.6,63.8,29.3z"></path>
              <path
                d="M2.5,6.5v87.1c0,1.5,1.2,2.7,2.7,2.7h31.7c1.5,0,2.7-1.2,2.7-2.7V82.6c0-1.5-1.2-2.7-2.7-2.7H18.8V20.1h18.1     c1.5,0,2.7-1.2,2.7-2.7V6.5c0-1.5-1.2-2.7-2.7-2.7H5.2C3.7,3.8,2.5,5,2.5,6.5z"></path>
            </g>
          </g>
        </switch>
      </svg>
      Thoát
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import {getUserName, authLogout} from '@/security/index'
import {FULL_NAME} from "@/constant";

export default {
  name: 'TheHeaderDropdownAccnt',
  data() {
    return {
      userName: getUserName(),
      fullName : localStorage.getItem(FULL_NAME)
    }
  },
  methods: {
    logout: function () {
      let that = this;
      that.$helper.loadDataSource({
        url: "/oauth/logout",
        successCallback: function (response) {
          authLogout(true);
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    }
  }
}
</script>

<style scoped>
.c-avatar-img {
  height: 34px;
  margin-right: 1rem;
}

.c-icon {
  margin-right: 0.3rem;
}

.menu-item-img {
  width: 1rem;
  margin-right: 10px;
  fill: gray;
}

.dropdown-item:hover .menu-item-img {
  fill: var(--primary-legacy-theme);
}

.dropdown-item:hover, .dropdown-item:focus {
  background-color: #f4f5f6;
}

.dropdown-menu .dropdown-divider {
  margin: 0;
}

.dropdown-menu .dropdown-item:not(:last-child) {
  border-bottom: 1px solid #edf2f9;
}
</style>
